import React from 'react';
import { CategorySelector } from '../CategorySelector';

interface Step3CategoryProps {
  categoryId: string;
  categoryPath: string;
  onCategorySelect: (id: string, path: string) => void;
  onClearCategory: () => void;
}

export const Step3Category: React.FC<Step3CategoryProps> = ({
  categoryId,
  onCategorySelect
}) => {
  return (
    <div>
      <CategorySelector
        selectedCategoryId={categoryId}
        onCategorySelect={onCategorySelect}
        compact={false}
      />
    </div>
  );
};
